import { Group, Select, MultiSelect, Button, Box, Collapse } from '@mantine/core'
import { IconCheck, IconX } from '@tabler/icons-react'

export interface UserFilters {
  role: string[] | null
  status: string | null
  kanidm: string | null
}

export const EMPTY_FILTERS: UserFilters = { role: null, status: null, kanidm: null }

export function countActiveFilters(filters: UserFilters): number {
  let count = 0
  if (filters.role && filters.role.length > 0) count++
  if (filters.status) count++
  if (filters.kanidm) count++
  return count
}

const STATUS_OPTIONS = [
  { value: 'active', label: 'Ativo' },
  { value: 'inactive', label: 'Inativo' },
  { value: 'pending_approval', label: 'Pendente' },
]

const KANIDM_OPTIONS = [
  { value: 'synced', label: 'Sincronizado' },
  { value: 'pending', label: 'Pendente' },
  { value: 'awaiting', label: 'Aguardando troca' },
]

export interface UsersFilterPanelProps {
  opened: boolean
  filters: UserFilters
  onFiltersChange: (filters: UserFilters) => void
  roleOptions: { value: string; label: string }[]
  onApply: () => void
  onClear: () => void
}

export function UsersFilterPanel({
  opened,
  filters,
  onFiltersChange,
  roleOptions,
  onApply,
  onClear,
}: UsersFilterPanelProps) {
  return (
    <Collapse in={opened}>
      <Box
        p="md"
        style={{
          background: 'var(--ai-border-light, #e6f3f5)',
          border: '1px solid var(--ai-border-medium, #b3dce2)',
          borderRadius: 'var(--mantine-radius-md)',
        }}
      >
        <Group align="end" gap="md">
          <MultiSelect
            label="Função"
            placeholder="Todas"
            data={roleOptions}
            value={filters.role ?? []}
            onChange={(value) =>
              onFiltersChange({ ...filters, role: value.length > 0 ? value : null })
            }
            clearable
            size="sm"
            style={{ minWidth: 200 }}
          />
          <Select
            label="Status"
            placeholder="Todos"
            data={STATUS_OPTIONS}
            value={filters.status}
            onChange={(value) => onFiltersChange({ ...filters, status: value })}
            clearable
            size="sm"
            style={{ minWidth: 160 }}
          />
          <Select
            label="Kanidm"
            placeholder="Todos"
            data={KANIDM_OPTIONS}
            value={filters.kanidm}
            onChange={(value) => onFiltersChange({ ...filters, kanidm: value })}
            clearable
            size="sm"
            style={{ minWidth: 180 }}
          />
          <Button size="sm" leftSection={<IconCheck size={14} />} onClick={onApply}>
            Aplicar
          </Button>
          <Button
            size="sm"
            variant="outline"
            leftSection={<IconX size={14} />}
            onClick={onClear}
          >
            Limpar
          </Button>
        </Group>
      </Box>
    </Collapse>
  )
}
